/**
 * Exit intent popup – section-level behavior.
 * Reads config from <script type="application/json" data-exit-intent-config>.
 * - Hash change: adjust popup alignment when hash matches popup id.
 * - First-step type: UserActivityMonitor (exit intent + inactivity + visibility).
 */
(function () {
  function getConfigs() {
    const scripts = Array.from(document.querySelectorAll('script[data-exit-intent-config]'));
    if (!scripts.length) return [];

    return scripts.reduce((configs, script) => {
      if (!script.textContent) return configs;
      try {
        const config = JSON.parse(script.textContent);
        configs.push(config);
      } catch (e) {
      }
      return configs;
    }, []);
  }

  function handleHashChange() {
    const hash = location.hash.slice(1);
    if (!hash) return;
    const targetDiv = document.getElementById(hash);
    if (!targetDiv) return;
    const contentDiv = targetDiv.querySelector('.exit-popup_content');
    if (!contentDiv) return;
    const contentHeight = contentDiv.getBoundingClientRect().height;
    const screenHeight = window.innerHeight || document.documentElement.clientHeight;
    if (contentHeight > screenHeight) {
      targetDiv.style.alignItems = 'start';
    } else {
      targetDiv.style.alignItems = '';
    }
  }

  class UserActivityMonitor {
    constructor(config) {
      this.config = config;
      this.inactivityTimeout = null;
      this.currentTriggerType = null;
      this.overlay = document.getElementById(config.popupId);
      this.closePopupButton = document.getElementById(config.popupId + '_close-btn');
      if (!this.overlay) return;
      this.initialize();
    }

    initialize() {
      this.attachEventListeners();
      this.resetInactivityTimer();
    }

    attachEventListeners() {
      document.addEventListener('mousemove', () => this.resetInactivityTimer());
      document.addEventListener('keydown', () => this.resetInactivityTimer());
      document.addEventListener('scroll', () => this.resetInactivityTimer());
      document.addEventListener('touchstart', () => this.resetInactivityTimer());
      document.addEventListener('touchmove', () => this.resetInactivityTimer());

      document.addEventListener('mouseout', (e) => {
        if (e.clientY < 10) {
          this.currentTriggerType = 'mouse_exit';
          this.showPopup();
        }
      });

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') {
          this.currentTriggerType = 'visibility_change';
          this.showPopup();
        }
      });

      if (this.closePopupButton) {
        this.closePopupButton.addEventListener('click', () => this.closePopup());
      }
    }

    resetInactivityTimer() {
      clearTimeout(this.inactivityTimeout);
      this.inactivityTimeout = setTimeout(() => {
        this.currentTriggerType = 'inactivity';
        this.showPopup();
      }, this.config.inactivityIntervalMs);
    }

    getTriggerType() {
      return this.currentTriggerType || 'unknown';
    }

    showPopup() {
      if (!window.location.href.includes('#')) {
        if (this.config.enableHeapTracking && typeof heap !== 'undefined' && typeof heap.track === 'function') {
          heap.track('exit_intent_popup_opened', {
            popup_id: this.config.popupId,
            custom_id: this.config.customPopupId || '',
            section_id: this.config.sectionId || '',
            popup_type: this.config.popupType || '',
            trigger_type: this.getTriggerType()
          });
        }
        window.location.hash = this.overlay.id;
      }
    }

    closePopup() {
      if (this.config.enableHeapTracking && typeof heap !== 'undefined' && typeof heap.track === 'function') {
        heap.track('exit_intent_popup_closed', {
          popup_id: this.config.popupId,
          custom_id: this.config.customPopupId || '',
          section_id: this.config.sectionId || '',
          popup_type: this.config.popupType || ''
        });
      }
      const closeTarget = (this.config.closeTarget || '').trim();
      window.location.hash = closeTarget ? '#' + closeTarget : '#';
      this.resetInactivityTimer();
    }
  }

  function init() {
    const configs = getConfigs();
    if (!configs.length) {
      return;
    }

    window.addEventListener('hashchange', handleHashChange);
    if (location.hash) {
      handleHashChange();
    }

    configs.forEach((config) => {
      if (config.popupType === 'first_step' && config.popupId && config.inactivityIntervalMs > 0) {
        new UserActivityMonitor(config);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
